// extracted by mini-css-extract-plugin
export default {"vertical":"Vertical_vertical__qgXvk"};